import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clientlogos() {
  return (
    <section
      className="banner-contact clientlogos p-100 text_white"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>Our Trusted Clients</h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-4"
          >
            <div className="client-logo-main">
              <div className="client-item">
                <StaticImage
                  src="../../../images/contact-updated/mobius_logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={178}
                  height={41}
                />
              </div>
              <div className="client-item">
                <StaticImage
                  src="../../../images/contact-updated/waste-logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={178}
                  height={51}
                />
              </div>
              <div className="client-item">
                <StaticImage
                  src="../../../images/contact-updated/kinder-morgan-logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={178}
                  height={45}
                />
              </div>
              <div className="client-item">
                <StaticImage
                  src="../../../images/contact-updated/uot-logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={144}
                  height={55}
                />
              </div>
              <div className="client-item">
                <StaticImage
                  src="../../../images/contact-updated/teemates-logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={178}
                  height={57}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientlogos;
